import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { SubscriptionPaths } from './route.paths';

export default function createSubscriptionRoutes(parents: DomainParents) {
  const withdrawalRoute = definePageRoute(parents, {
    path: SubscriptionPaths.withdrawal,
    title: m.subscription_withdrawal_page_title,
    description: m.subscription_withdrawal_page_meta_description,
    flag: 'page-withdrawal',
    page: () => import('./Withdrawal.page'),
  });

  const cancellationRoute = definePageRoute(parents, {
    path: SubscriptionPaths.cancellation,
    title: m.subscription_cancellation_page_title,
    description: m.subscription_cancellation_page_meta_description,
    flag: 'page-public-cancellation',
    page: () => import('./Cancellation.page'),
  });

  return defineDomainRoutes({
    authenticated: [] as const,
    public: [withdrawalRoute, cancellationRoute] as const,
  });
}
